import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  context: {
    isLoading: false,
    data: {
      clinica: null,
      paciente: null,
      teleconsultas: null,
      teleavaliacoes: null,
      isLogged: false,
      jwt: null,
      // objeto de medicos de consultas que o paciente possui
      // {74: {nome: 'Marcio Silva', especialidade: 'Cardiologia'}, ...}
      medicos: null,
    },
    receivedAt: null,
    query: null
  },
  saveDataToNfse: {
    isLoading: false,
  },
  savePersonalData: {
    isLoading: false,
  },
  savePacienteDoc: {
    isLoading: false,
  }
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.REQUEST_DATA_BY_CONTEXT:
    case types.RECEIVE_DATA_BY_CONTEXT:
      return {
        ...state,
        context: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.context.data,
          receivedAt: action.receivedAt,
          query: (action.query) ? action.query : state.context.query,
          error: action.error,
        }
      }
    case types.REQUEST_SAVE_DATA_TO_NFSE:
    case types.RECEIVE_SAVE_DATA_TO_NFSE:
      return {
        ...state,
        saveDataToNfse: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_SAVE_PERSONAL_DATA:
    case types.RECEIVE_SAVE_PERSONAL_DATA:
      return {
        ...state,
        savePersonalData: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_SAVE_DOC_PACIENTE:
    case types.RECEIVE_SAVE_DOC_PACIENTE:
      return {
        ...state,
        savePacienteDoc: {
          isLoading: action.isLoading,
        }
      }
    case types.RESET_DATA_CONTEXT:
      return {
        ...state,
        context: INITIAL_STATE.context
      }
    default:
      return state
  }
}
